import React, { useEffect } from "react";
import { useState } from "react";
import {
  Button,
  Card,
  Divider,
  FormControl,
  Grid,
  InputAdornment,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import NumberFormatting from "../../helper/NumberFormatting";
import { getPurchaseOrderCust } from "../../../redux/reducer/purchaseOrderCust/purchaseOrderCustReducer";
import { getCustomer } from "../../../redux/reducer/customer/customerReducer";
import { getEmployee } from "../../../redux/reducer/employee/employeeReducer";
import { getGoodsOperational } from "../../../redux/reducer/goodsOperational/goodsOperationalReducer";
import {
  deliveryOrderActions,
  getDeliveryOrderById,
  updateDeliveryOrder,
} from "../../../redux/reducer/deliveryOrder/deliveryOrderReducer";
import { getDeliveryVehicle } from "../../../redux/reducer/deliveryVehicle/deliveryVehicleReducer";

const useStyles = makeStyles(() => ({
  headerClass: {
    display: "flex",
    alignItems: "flex-start",
    width: "100%",
    flexDirection: "column",
    padding: "5px",
    margin: "10px 0px",
    background: "#F2F2F2",
  },
  dividerStyle: {
    border: "1px solid #386E5B",
    width: "100%",
    margin: "5px 0px",
  },
  footerButton: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    marginBottom: "10px",
    width: "99%",
  },
  tableHeader: {
    background: "#ddd",
    textAlign: "center",
    borderBottom: "1px solid #D1CDCD",
    padding: "1em",
  },
  tableCell: {
    background: "#ddd",
    borderBottom: "1px solid #D1CDCD",
    padding: "5px 0px",
  },
  actionButtonEdit: {
    backgroundColor: "#dde0f0",
    color: "#A0A3B3",
    fontSize: "25px",
    textAlign: "center",
    borderRadius: "5px",
    margin: "auto",
    cursor: "pointer",
    "&:hover": {
      background: "#7dbda9",
    },
  },
}));
export default function AdminDeliveryOrderDetail() {
  // Navigate
  const navigate = useNavigate();
  const { id } = useParams();

  // Styling
  const styles = useStyles();

  // Redux Data
  const dispatch = useDispatch();
  const data = useSelector((state) => state.deliveryOrder.data);
  const token = useSelector((state) => state.auth.token);
  const customer = useSelector((state) => state.customer.data);
  const purchaseOrderCust = useSelector(
    (state) => state.purchaseOrderCust.data
  );
  const employee = useSelector((state) => state.employee.data);
  const deliveryVehicle = useSelector((state) => state.deliveryVehicle.data);
  const goodsOperational = useSelector((state) => state.goodsOperational.data);
  const user = useSelector((state) => state.auth.dataToken);

  // Local State
  const [formData, setFormData] = useState({
    purchaseOrderId: "",
    deliveryOrderCode: "",
    customerId: "",
    employeeId: "",
    vehicleId: "",
    operationalGoodsId: "",
    incoming: "",
    outcoming: "",
    totalPrices: "",
    description: ""
  });
  const [orderDetails, setOrderDetails] = useState([]);
  const [fetch, setFetch] = useState(true);

  // Column
  const orderDetailsColumn = [
    "SAYURAN",
    "ORDER",
    "DELIVER",
    "RECEIVE",
    "DEVIATION",
    "TOTAL ORDER",
    "HARGA",
  ];

  useEffect(() => {
    if (fetch) {
      let x = data.docs.findIndex((item) => item._id === id);
      if (x > -1) {
        setFormData({
          purchaseOrderId: data.docs[x].purchaseOrderId
            ? data.docs[x].purchaseOrderId._id
            : "",
          purchaseOrderCode: data.docs[x].purchaseOrderId
            ? data.docs[x].purchaseOrderId.purchaseOrderCode
            : "",
          deliveryOrderCode: data.docs[x].deliveryOrderCode
            ? data.docs[x].deliveryOrderCode
            : "",
          customerId: data.docs[x].customerId
            ? data.docs[x].customerId._id
            : "",
          customerName: data.docs[x].customerId
            ? data.docs[x].customerId.customerName
            : "",
          employeeId: data.docs[x].deliveryDetails.employeeId
            ? data.docs[x].deliveryDetails.employeeId._id
            : "",
          employeeName: data.docs[x].deliveryDetails.employeeId
            ? data.docs[x].deliveryDetails.employeeId.fullName
            : "",
          vehicleId: data.docs[x].deliveryDetails.vehicleId
            ? data.docs[x].deliveryDetails.vehicleId._id
            : "",
          numberPlate: data.docs[x].deliveryDetails.vehicleId
            ? data.docs[x].deliveryDetails.vehicleId.numberPlate
            : "",
          operationalGoodsId: data.docs[x].deliveryDetails.operationalGoods
            ? data.docs[x].deliveryDetails.operationalGoods.operationalGoodsId
                ._id
            : "",
          operationalGoodsName: data.docs[x].deliveryDetails.operationalGoods
            ? data.docs[x].deliveryDetails.operationalGoods.operationalGoodsId
                .nameOfGoods
            : "",
          description: data.docs[x].deliveryDetails.description
          ? data.docs[x].deliveryDetails.description
          : "",
          incoming: data.docs[x].deliveryDetails.operationalGoods
            ? data.docs[x].deliveryDetails.operationalGoods.incoming
            : "",
          outcoming: data.docs[x].deliveryDetails.operationalGoods
            ? data.docs[x].deliveryDetails.operationalGoods.outcoming
            : "",
          totalPrices: data.docs[x].totalPrices ? data.docs[x].totalPrices : "",
        });
        setOrderDetails([...data.docs[x].orderDetails]);
      }
      setFetch(false);
    }
  }, [fetch]);

  // Basic Handle Change
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // Handling Order Details
  const handleOrderDetails = (index) => (e) => {
    const newItems = [...orderDetails];
    newItems[index][e.target.name] = e.target.value;
    newItems[index]["totalOrder"] = newItems[index]["deliver"];
    newItems[index]["price"] =
      newItems[index]["totalOrder"] *
      orderDetails[index].vegetablePriceId.price;

    setFormData({
      ...formData,
      totalPrices: newItems.reduce(
        (acc, cur) => parseInt(acc) + parseInt(cur.price),
        0
      ),
    });
    setOrderDetails(newItems);
  };

  const loadMore = (value) => (event) => {
    if (
      event.target.scrollHeight - event.target.scrollTop < 300 &&
      event.target.scrollTop < 100
    ) {
      if (
        purchaseOrderCust.totalDocs !== purchaseOrderCust.docs.length &&
        value === 1
      ) {
        const getData = {
          params: {
            limit: purchaseOrderCust.limit + 10,
            page: 1,
          },
          token: token,
        };
        dispatch(getPurchaseOrderCust(getData));
      } else if (customer.totalDocs !== customer.docs.length && value === 2) {
        const getData = {
          params: {
            limit: customer.limit + 10,
            page: 1,
          },
          token: token,
        };
        dispatch(getCustomer(getData));
      } else if (employee.totalDocs !== employee.docs.length && value === 3) {
        const getData = {
          params: {
            limit: employee.limit + 10,
            page: 1,
          },
          token: token,
        };
        dispatch(getEmployee(getData));
      } else if (
        deliveryVehicle.totalDocs !== deliveryVehicle.docs.length &&
        value === 4
      ) {
        const getData = {
          params: {
            limit: deliveryVehicle.limit + 10,
            page: 1,
          },
          token: token,
        };
        dispatch(getDeliveryVehicle(getData));
      } else if (
        goodsOperational.totalDocs !== goodsOperational.docs.length &&
        value === 5
      ) {
        const getData = {
          params: {
            limit: goodsOperational.limit + 10,
            page: 1,
          },
          token: token,
        };
        dispatch(getGoodsOperational(getData));
      }
    }
  };

  const handleSubmitAll = (e) => {
    e.preventDefault();
    Swal.fire({
      title: `Mohon dicek kembali data yang akan di input`,
      icon: "warning",
      buttons: true,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Tambah",
      cancelButtonText: "Batal",
    }).then((confirm) => {
      if (confirm.isConfirmed) {
        let data = {
          value: {
            purchaseOrderId: formData.purchaseOrderId,
            deliveryOrderCode: formData.deliveryOrderCode,
            customerId: formData.customerId,
            orderDetails: orderDetails,
            deliveryDetails: {
              employeeId: formData.employeeId,
              vehicleId: formData.vehicleId,
              operationalGoods: {
                operationalGoodsId: formData.operationalGoodsId,
                incoming: formData.incoming,
                outcoming: formData.outcoming,
              },
            },
            totalPrices: formData.totalPrices,
            createdBy: user.username,
            updatedBy: user.username,
          },
          token: token,
          id: id,
        };
        dispatch(updateDeliveryOrder(data)).then((res) => {
          if (res.payload.status === 200) {
            let dataGetById = {
              id: res.payload.data._id,
              token: token,
            };
            dispatch(getDeliveryOrderById(dataGetById)).then((result) => {
              dispatch(
                deliveryOrderActions.editDeliveryOrder(result.payload.data)
              );
              toast.success(res.payload.message);
              navigate("/admin/surat-jalan");
            });
          }
        });
      } else {
        return;
      }
    });
  };

  return (
    <Grid container>
      <ToastContainer />

      <Card className={styles.headerClass}>
        <Typography fontSize={20} fontWeight={600} color={"#0A543B"}>
          DETAIL SURAT JALAN
        </Typography>
      </Card>
      <form
        style={{ display: "flex", flexDirection: "column", width: "100%" }}
        onSubmit={handleSubmitAll}
      >
        <Card className={styles.headerClass}>
          <Grid
            container
            direction={"row"}
            justifyContent={"space-between"}
            alignItems="center"
            minWidth={"100%"}
          >
            <Grid items>
              <Typography fontSize={16} color={"#2D6B56"} variant="h6">
                INFORMASI SURAT JALAN
              </Typography>
            </Grid>
          </Grid>
          <Divider className={styles.dividerStyle} />

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              margin: "10px 0px",
              flexDirection: "row",
              background: "none",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              KODE SURAT JALAN
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{
                maxLength: 20,
                style: { background: "white" },
                readOnly: true,
              }}
              required
              helperText={
                formData.deliveryOrderCode.length > 0
                  ? /^[A-Za-z]{2}-\d{5}/.test(formData.deliveryOrderCode)
                    ? ""
                    : "*Format Kode Karyawan salah"
                  : ""
              }
              size="small"
              error={
                formData.deliveryOrderCode.length > 0
                  ? /^[A-Za-z]{2}-\d{5}/.test(formData.deliveryOrderCode)
                    ? false
                    : true
                  : false
              }
              name="deliveryOrderCode"
              onChange={handleChange}
              value={formData.deliveryOrderCode}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
              background: "none",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              KODE PO
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ readOnly: true }}
              required
              select
              size="small"
              error={false}
              name="purchaseOrderId"
              onChange={handleChange}
              value={formData.purchaseOrderId}
              fullWidth
              variant="outlined"
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    onScroll: loadMore(1),
                  },
                  style: {
                    height: "300px",
                  },
                },
              }}
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            >
              {formData.purchaseOrderCode &&
                formData.purchaseOrderId.length > 0 && (
                  <MenuItem value={formData.purchaseOrderId} key={0}>
                    {formData.purchaseOrderCode}
                  </MenuItem>
                )}
              {purchaseOrderCust.docs.length > 0 ? (
                purchaseOrderCust.docs.map((data, index) => (
                  <MenuItem value={data._id} key={index}>
                    {data.purchaseOrderCode}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="">Data kosong</MenuItem>
              )}
            </TextField>
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              marginBottom: "10px",
              width: "100%",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              CUSTOMER
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ readOnly: true }}
              required
              select
              size="small"
              error={false}
              name="customerId"
              onChange={handleChange}
              value={formData.customerId}
              fullWidth
              variant="outlined"
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    onScroll: loadMore(2),
                  },
                  style: {
                    height: "300px",
                  },
                },
              }}
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            >
              {formData.customerName && formData.customerId.length > 0 && (
                <MenuItem value={formData.customerId} key={0}>
                  {formData.customerName}
                </MenuItem>
              )}
              {customer.docs.length > 0 ? (
                customer.docs.map((data, index) => (
                  <MenuItem value={data._id} key={index}>
                    {data.customerName}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="">Data kosong</MenuItem>
              )}
            </TextField>
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              marginBottom: "10px",
              width: "100%",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              TOTAL HARGA
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ readOnly: true, style: { background: "white" } }}
              required
              size="small"
              error={false}
              name="totalPrices"
              onChange={handleChange}
              value={formData.totalPrices.toLocaleString("id", {
                style: "currency",
                currency: "IDR",
              })}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                marginRight: "10px",
              }}
            />
          </FormControl>
        </Card>

        <Card className={styles.headerClass}>
          <Grid
            container
            direction={"row"}
            justifyContent={"space-between"}
            alignItems="center"
            minWidth={"100%"}
          >
            <Grid items>
              <Typography fontSize={16} color={"#2D6B56"} variant="h6">
                DETAIL ORDER
              </Typography>
            </Grid>
          </Grid>
          <Divider className={styles.dividerStyle} />
          <table
            style={{
              width: "98%",
              margin: "10px",
              borderCollapse: "collapse",
              borderRadius: "1em",
              overflow: "hidden",
            }}
          >
            <thead>
              {orderDetailsColumn.map((item, index) => {
                return (
                  <td className={styles.tableHeader} key={index}>
                    {item}
                  </td>
                );
              })}
            </thead>
            <tbody>
              {orderDetails.length > 0 &&
                orderDetails.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td className={styles.tableCell} style={{ width: "300px" }}>
                        <FormControl
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyItems: "flex-start",
                            flexDirection: "row",
                            margin: "auto",
                            width: "90%",
                          }}
                        >
                          <TextField
                            select
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ readOnly: true }}
                            required
                            size="small"
                            error={false}
                            name="vegetablePriceId"
                            onChange={handleOrderDetails(index)}
                            value={item.vegetablePriceId._id}
                            fullWidth
                            variant="outlined"
                            SelectProps={{
                              MenuProps: {
                                style: {
                                  height: "300px",
                                },
                              },
                            }}
                            style={{
                              maxWidth: "400px",
                              background: "white",
                              marginRight: "10px",
                            }}
                          >
                            <MenuItem
                              value={item.vegetablePriceId._id}
                              key={index}
                            >
                              {item.vegetablePriceId.vegetableName}
                            </MenuItem>
                          </TextField>
                        </FormControl>
                      </td>

                      <td className={styles.tableCell} style={{ width: "100px" }}>
                        <FormControl
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyItems: "flex-start",
                            flexDirection: "row",
                            margin: "auto",
                            width: "90%",
                          }}
                        >
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            inputPRops={{ readOnly: true }}
                            required
                            size="small"
                            InputProps={{
                              inputComponent: NumberFormatting,
                              endAdornment: (
                                <InputAdornment position="end"></InputAdornment>
                              ),
                            }}
                            error={false}
                            name="order"
                            id={index}
                            onChange={handleOrderDetails(index)}
                            value={item.order}
                            variant="outlined"
                            fullWidth
                            style={{
                              background: "white",
                              marginRight: "10px",
                            }}
                          />
                        </FormControl>
                      </td>

                      <td className={styles.tableCell} style={{ width: "100px" }}>
                        <FormControl
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyItems: "flex-start",
                            flexDirection: "row",
                            margin: "auto",
                            width: "90%",
                          }}
                        >
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ readOnly: true }}
                            required
                            size="small"
                            InputProps={{
                              inputComponent: NumberFormatting,
                              endAdornment: (
                                <InputAdornment position="end"></InputAdornment>
                              ),
                            }}
                            error={false}
                            name="deliver"
                            id={index}
                            onChange={handleOrderDetails(index)}
                            value={item.deliver}
                            variant="outlined"
                            fullWidth
                            style={{
                              background: "white",
                              marginRight: "10px",
                            }}
                          />
                        </FormControl>
                      </td>

                      <td className={styles.tableCell} style={{ width: "100px" }}>
                        <FormControl
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyItems: "flex-start",
                            flexDirection: "row",
                            margin: "auto",
                            width: "90%",
                          }}
                        >
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ readOnly: true }}
                            required
                            size="small"
                            InputProps={{
                              inputComponent: NumberFormatting,
                              endAdornment: (
                                <InputAdornment position="end"></InputAdornment>
                              ),
                            }}
                            error={false}
                            name="receive"
                            id={index}
                            onChange={handleOrderDetails(index)}
                            value={item.receive}
                            variant="outlined"
                            fullWidth
                            style={{
                              background: "white",
                              marginRight: "10px",
                            }}
                          />
                        </FormControl>
                      </td>

                      <td className={styles.tableCell} style={{ width: "100px" }}>
                        <FormControl
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyItems: "flex-start",
                            flexDirection: "row",
                            margin: "auto",
                            width: "90%",
                          }}
                        >
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ readOnly: true }}
                            required
                            size="small"
                            InputProps={{
                              inputComponent: NumberFormatting,
                              endAdornment: (
                                <InputAdornment position="end"></InputAdornment>
                              ),
                            }}
                            error={false}
                            name="deviation"
                            id={index}
                            onChange={handleOrderDetails(index)}
                            value={item.deviation}
                            variant="outlined"
                            fullWidth
                            style={{
                              background: "white",
                              marginRight: "10px",
                            }}
                          />
                        </FormControl>
                      </td>

                      <td className={styles.tableCell}>
                        <FormControl
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyItems: "flex-start",
                            flexDirection: "row",
                            margin: "auto",
                            width: "90%",
                          }}
                        >
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ readOnly: true }}
                            required
                            size="small"
                            InputProps={{
                              inputComponent: NumberFormatting,
                              endAdornment: (
                                <InputAdornment position="end"></InputAdornment>
                              ),
                            }}
                            error={false}
                            name="totalOrder"
                            id={index}
                            onChange={handleOrderDetails(index)}
                            value={item.totalOrder}
                            variant="outlined"
                            fullWidth
                            style={{
                              background: "white",
                              marginRight: "10px",
                            }}
                          />
                        </FormControl>
                      </td>

                      <td className={styles.tableCell}>
                        <FormControl
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyItems: "flex-start",
                            flexDirection: "row",
                            margin: "auto",
                            width: "90%",
                          }}
                        >
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            InputProps={{ readOnly: true }}
                            required
                            size="small"
                            error={false}
                            name="price"
                            id={index}
                            onChange={handleOrderDetails(index)}
                            value={item.price.toLocaleString("id", {
                              style: "currency",
                              currency: "IDR",
                            })}
                            variant="outlined"
                            fullWidth
                            style={{
                              background: "white",
                              marginRight: "10px",
                            }}
                          />
                        </FormControl>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </Card>

        <Card className={styles.headerClass}>
          <Grid
            container
            direction={"row"}
            justifyContent={"space-between"}
            alignItems="center"
            minWidth={"100%"}
          >
            <Grid items>
              <Typography fontSize={16} color={"#2D6B56"} variant="h6">
                DETAIL PENGIRIMAN
              </Typography>
            </Grid>
          </Grid>
          <Divider className={styles.dividerStyle} />

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              marginTop: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              PILIH KARYAWAN
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ readOnly: true }}
              required
              select
              size="small"
              error={false}
              name="employeeId"
              onChange={handleChange}
              value={formData.employeeId}
              fullWidth
              variant="outlined"
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    onScroll: loadMore(3),
                  },
                  style: {
                    height: "300px",
                  },
                },
              }}
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            >
              {formData.employeeName && formData.employeeId.length > 0 && (
                <MenuItem value={formData.employeeId} key={0}>
                  {formData.employeeName}
                </MenuItem>
              )}
              {employee.docs.length > 0 ? (
                employee.docs.map((data, index) => (
                  <MenuItem value={data._id} key={index}>
                    {data.fullName}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="">Data kosong</MenuItem>
              )}
            </TextField>
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              PILIH KENDARAAN
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ readOnly: true }}
              required
              select
              size="small"
              error={false}
              name="vehicleId"
              onChange={handleChange}
              value={formData.vehicleId}
              fullWidth
              variant="outlined"
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    onScroll: loadMore(4),
                  },
                  style: {
                    height: "300px",
                  },
                },
              }}
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            >
              {formData.numberPlate && formData.vehicleId.length > 0 && (
                <MenuItem value={formData.vehicleId} key={0}>
                  {formData.numberPlate}
                </MenuItem>
              )}
              {deliveryVehicle.docs.length > 0 ? (
                deliveryVehicle.docs.map((data, index) => (
                  <MenuItem value={data._id} key={index}>
                    {`${data.numberPlate} - ${data.vehicleType} - ${data.model}`}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="">Data kosong</MenuItem>
              )}
            </TextField>
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              PILIH KERANJANG
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ readOnly: true }}
              required
              select
              size="small"
              error={false}
              name="operationalGoodsId"
              onChange={handleChange}
              value={formData.operationalGoodsId}
              fullWidth
              variant="outlined"
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    onScroll: loadMore(5),
                  },
                  style: {
                    height: "300px",
                  },
                },
              }}
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            >
                 {formData.operationalGoodsName && formData.operationalGoodsId.length > 0 && (
                <MenuItem value={formData.operationalGoodsId} key={0}>
                  {formData.operationalGoodsName}
                </MenuItem>
              )}
              {goodsOperational.docs.length > 0 ? (
                goodsOperational.docs.map((data, index) => (
                  <MenuItem value={data._id} key={index}>
                    {`${data.nameOfGoods} - ${data.categoryId.categoryName}`}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="">Data kosong</MenuItem>
              )}
            </TextField>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ readOnly: true }}
              required
              size="small"
              InputProps={{
                inputComponent: NumberFormatting,
                endAdornment: <InputAdornment position="end"></InputAdornment>,
              }}
              error={false}
              name="incoming"
              placeholder="incoming"
              onChange={handleChange}
              value={formData.incoming}
              variant="outlined"
              style={{
                background: "white",
                marginRight: "10px",
                width: "110px",
              }}
            />
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ readOnly: true }}
              required
              size="small"
              InputProps={{
                inputComponent: NumberFormatting,
                endAdornment: <InputAdornment position="end"></InputAdornment>,
              }}
              error={false}
              name="outcoming"
              placeholder="outcoming"
              onChange={handleChange}
              value={formData.outcoming}
              variant="outlined"
              style={{
                background: "white",
                marginRight: "10px",
                width: "110px",
              }}
            />
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              marginTop: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              KETERANGAN
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              required
              size="small"
              error={false}
              name="description"
              onChange={handleChange}
              value={formData.description}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <div className={styles.footerButton}>
            <Button
              variant="contained"
              color="error"
              style={{ marginLeft: "10px" }}
              onClick={() => navigate("/admin/surat-jalan")}
            >
              KEMBALI
            </Button>
          </div>
        </Card>
      </form>
    </Grid>
  );
}
